import groupBy from "lodash/groupBy";
import toPairs from "lodash/toPairs";
import React from "react";

import { type FormatterUnit, isFormatterUnit } from "~/tools/formatter-unit";
import { ALL_FORMATTERS } from "~/tools/formatter-unit/all-formatters";

import { Select, type SelectOptionGroup, type SelectProps } from "../_select";

const UNIT_OPTIONS: ReadonlyArray<SelectOptionGroup<FormatterUnit>> = toPairs(groupBy(ALL_FORMATTERS, "group")).map(
	([label, items]) => ({
		label,
		options: items.map(({ id, name }) => ({ value: id, label: name })),
	}),
);

export interface UnitPickerProps extends Omit<SelectProps<FormatterUnit>, "value" | "options"> {
	unit: undefined | string;
}

export const UnitPicker: React.FC<UnitPickerProps> = ({ unit, ...props }) => (
	<Select
		filterBy={["label", "value"]}
		notFoundContent="No units found"
		options={UNIT_OPTIONS}
		value={unit == null || !isFormatterUnit(unit) ? undefined : unit}
		{...props}
	/>
);
